const ANALYTICS_ID = "G-QCZV5LR391";
const CONTACT_CONVERSION = "AW-18406933325/npgdCOzDk-ccEM2GjslE";

const getGtag = () => {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag === "function") return window.gtag;
  return function gtag() {
    window.dataLayer.push(arguments);
  };
};

export const trackContactConversion = (onDone) => {
  const finish = (() => {
    let done = false;
    return () => {
      if (done) return;
      done = true;
      if (typeof onDone === "function") onDone();
    };
  })();

  try {
    if (typeof window === "undefined") {
      finish();
      return;
    }

    const gtag = getGtag();
    gtag("event", "conversion", {
      send_to: CONTACT_CONVERSION,
      value: 1.0,
      currency: "CLP",
      event_callback: finish,
    });
    gtag("event", "generate_lead", { send_to: ANALYTICS_ID });
    window.setTimeout(finish, 1000);
  } catch (error) {
    console.warn("No se pudo registrar la conversión", error);
    finish();
  }
};

export const trackLeadConversion = () => trackContactConversion();

/**
 * Evento de analítica genérico. Se envía a GA4 y, si el pixel está
 * instalado en la página, también a Meta Pixel como evento personalizado.
 * Nunca lanza: la analítica jamás debe bloquear una conversión.
 */
export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window === "undefined") return;
    getGtag()("event", name, { send_to: ANALYTICS_ID, ...params });
    if (typeof window.fbq === "function") {
      window.fbq("trackCustom", name, params);
    }
  } catch (error) {
    console.warn("No se pudo registrar el evento", name, error);
  }
};

/**
 * Click en cualquier CTA de WhatsApp: registra el evento de intención con su
 * contexto (sección y pack) y dispara la conversión de Google Ads antes de
 * abrir WhatsApp mediante el callback.
 */
export const trackWhatsAppLead = ({ location, pack, value, currency = "CLP" } = {}, onDone) => {
  trackEvent("whatsapp_click", {
    cta_location: location,
    pack: pack || "sin_pack",
    ...(value ? { value, currency } : {}),
  });

  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "Contact", { content_name: pack || location });
    }
  } catch (error) {
    console.warn("No se pudo registrar el evento en Meta Pixel", error);
  }

  trackContactConversion(onDone);
};

/**
 * Envío exitoso de un formulario de lead: registra el evento con su contexto
 * y dispara la conversión estándar (Google Ads + Meta Pixel "Lead").
 */
export const trackFormLead = ({ form, pack } = {}) => {
  trackEvent("form_submit", { form: form || "lead", pack: pack || "sin_pack" });

  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "Lead", { content_name: pack || form });
    }
  } catch (error) {
    console.warn("No se pudo registrar el lead en Meta Pixel", error);
  }

  trackContactConversion();
};
